/** Last time the user had an authenticated tab in the foreground (ISO string in localStorage). */
export const LAST_SESSION_ACTIVITY_AT_KEY = 'lastSessionActivityAt';

/** Require full login again if the app was not used for longer than this while credentials were stored. */
export const SESSION_INACTIVITY_MS = 14 * 24 * 60 * 60 * 1000; // 14 days (aligned with StafflyMobile)

/** Bump activity timestamp when a JWT is present (call on login and when the tab becomes active). */
export function touchSessionActivity(): void {
  try {
    if (typeof window === 'undefined') return;
    const token = localStorage.getItem('authToken');
    if (token) {
      localStorage.setItem(LAST_SESSION_ACTIVITY_AT_KEY, new Date().toISOString());
    }
  } catch {
    // ignore quota / private mode
  }
}

export function clearSessionActivityMarker(): void {
  try {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(LAST_SESSION_ACTIVITY_AT_KEY);
  } catch {
    // ignore
  }
}
